'use client';

import { createTheme } from '@mui/material/styles';
import { applyPrimaryColor } from './apply-primary-color';
import theme from './base';

// Create a theme instance.
const base = createTheme(theme, {
  palette: {
    background: {
      primary: '#fbeaea',
      gradient: {
        main: 'linear-gradient(to right, #BF4D6A 0%, #FF3333 51.56%, #FF532E 100%)',
        dark: 'linear-gradient(to right, #a2425a 0%, #da2c2c 51.56%, #d84626 100%)',
        light:
          'linear-gradient(to right, #a2425a 0%, #da2c2c 51.56%, #d84626 100%)',
        contrastText: '#fff',
      },
    },

    primary: theme.palette['disc-d'],
  },
});

export const light = applyPrimaryColor(base);

export const dark = light;
